const BASE_URL = "https://api.dev.auxo.dk/public/v2/content";

export async function fetchPages() {
  try {
    const res = await fetch(`${BASE_URL}/pages?limit=100`);
    if (!res.ok) throw new Error("Failed to fetch pages");
    const data = await res.json();
    return data.items || [];
  } catch (error) {
    console.error("fetchPages error:", error);
    return [];
  }
}

export async function fetchMenuItems() {
  try {
    const res = await fetch(`${BASE_URL}/menu_items?limit=100&sort=order&order=asc`);
    if (!res.ok) throw new Error("Failed to fetch menu items");
    const data = await res.json();
    return data.items || [];
  } catch (error) {
    console.error("fetchMenuItems error:", error);
    return [];
  }
}

export async function fetchReviews() {
  try {
    const res = await fetch(`${BASE_URL}/reviews?limit=100&sort=order&order=asc`);
    if (!res.ok) throw new Error("Failed to fetch reviews");
    const data = await res.json();
    return data.items || [];
  } catch (error) {
    console.error("fetchReviews error:", error);
    return [];
  }
}

export async function fetchProducts() {
  try {
    const res = await fetch(`${BASE_URL}/products?limit=100&sort=order&order=asc`);
    if (!res.ok) throw new Error("Failed to fetch products");
    const data = await res.json();
    return data.items || [];
  } catch (error) {
    console.error("fetchProducts error:", error);
    return [];
  }
}

export async function fetchGallery(slug) {
  try {
    const res = await fetch(`${BASE_URL}/gallery?gallery_slug=${slug}`);
    if (!res.ok) throw new Error("Failed to fetch gallery");
    const data = await res.json();
    return data.items?.[0] || null;
  } catch (error) {
    console.error("fetchGallery error:", error);
    return null;
  }
}

export async function fetchPageBySlug(slug) {
  try {
    const cleanSlug = slug.replace(/\/$/, "");
    const res = await fetch(`${BASE_URL}/pages?page_slug=${cleanSlug}`);
    if (!res.ok) throw new Error("Failed to fetch page");
    const data = await res.json();
    return data.items?.[0] || null;
  } catch (error) {
    console.error("fetchPageBySlug error:", error);
    return null;
  }
}
